import { useId } from "react";
import ReviewCard from "@/components/campaignBuilder/review/ReviewCard/ReviewCard";
import WalletSelect from "@/components/campaignBuilder/WalletSelect";
import { FUNDING_WALLET_TEXT } from "@/constants/campaignBuilder";
import { useCampaignBuilder } from "@/context/CampaignBuilderContext";
import { isBudgetLocked } from "@/utils/campaign-gating-helper";

/**
 * Step 4's funding-wallet card, above the checkout: which wallet pays comes before reading the cost,
 * and every figure in the Cost Summary depends on it. Multi-group plans only.
 */
export default function FundingWalletCard() {
  const {
    canChooseWallet,
    fundingWallets,
    fundingWalletsLoading,
    fundingGroupId,
    chooseFundingWallet,
    campaignStatus,
  } = useCampaignBuilder();
  const hintId = useId();

  if (!canChooseWallet) return null;
  const selected = fundingWallets.find((w) => w.groupId === fundingGroupId);

  return (
    <ReviewCard title={FUNDING_WALLET_TEXT.reviewTitle}>
      <WalletSelect
        label={FUNDING_WALLET_TEXT.groupLabel}
        wallets={fundingWallets}
        value={fundingGroupId}
        onChange={(id) => void chooseFundingWallet(id)}
        disabled={fundingWalletsLoading || isBudgetLocked(campaignStatus)}
        aria-describedby={selected ? hintId : undefined}
      />
      {selected && (
        <p id={hintId} className="mt-2 mb-0 font-lato text-[12px] text-graphite">
          {FUNDING_WALLET_TEXT.managedBy(selected.name)}
        </p>
      )}
    </ReviewCard>
  );
}
